import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Button from 'src/components/atoms/Button'
// import ProgressTracker from "src/components/molecules/ProgressTracker";
import StoreMedia from 'src/pages/signup-steps/StoreMedia'
import StoreInformation from 'src/pages/signup-steps/StoreInformation'
import StoreHours from 'src/pages/signup-steps/StoreHours'
import AccountInformation from 'src/pages/signup-steps/AccountInformation'
import DiningOptions from 'src/pages/signup-steps/DiningOptions'
import Logo from 'src/logos/Logo'
import css from './Signup.module.scss'
import { useEffect, useState } from 'react'
import { setStep } from 'src/slices/signup'
import { clearCurrentMarker } from 'src/slices/location'
// import { getBusinessInfoSignup } from 'src/slices/signup'
import { clearState } from 'src/slices/info'
import { handleStatus } from 'src/slices/utils'
import { useLocation, useNavigate } from 'react-router-dom'
import SignupFinish from './signup-steps/SignupFinish'
// import { Prompt } from 'react-router'

export default function Signup() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const location = useLocation()

	const { token } = useSelector(state => state.auth)
	const { status } = useSelector(state => state.info)
	const { step } = useSelector(state => state.signup)
	const { isFirst, businessInfo } = useSelector(state => state.signup)
	const [isMount, setIsMount] = useState(true)

	const [showedHoursToast, setShowedHoursToast] = useState(false)

	// The order is important
	// TODO: Rename these so title and component match
	const steps = [
		{ title: 'Account Information', component: <AccountInformation /> },
		{ title: 'Store Information', component: <StoreInformation isSignupMount={isMount} /> },
		{ title: 'Store Hours', component: <StoreHours /> },
		{ title: 'Store Media', component: <StoreMedia /> },
		{ title: 'Dining Options', component: <DiningOptions /> },
		{ title: 'Signup Complete!', component: <SignupFinish /> },
	]

	useEffect(() => {
		if (isFirst) {
			dispatch(setStep(0))
			dispatch(clearCurrentMarker())
		} else {
			toast.info('Please complete the signup process')
		}
	}, [])

	useEffect(() => {
		if (businessInfo.isHoursAccurate === false) {
			setShowedHoursToast(true)
			toast.warning(
				'Please review the store hours, there was an issue while auto-filling them'
			)
		}
	}, [businessInfo.isHoursAccurate])

	useEffect(() => {
		handleStatus(
			status.updateBusinessInfo,
			() => dispatch(clearState(status.updateBusinessInfo)),
			{
				isSuccess: { toast: false },
			}
		)
	}, [status.updateBusinessInfo])

	return (
		<div className={css['page']}>
			{/* <Prompt message='Are you sure you want to leave?'></Prompt> */}
			{/* <Prompt when={isPrompt()} message={() => 'Are you sure you want to leave this page?'} /> */}
			<div className={css['box']}>
				<Logo width='260px' />
				{/* <ProgressTracker activeStep={getstep?.step} steps={steps} /> */}

				<div className={css['component']}>
					<h1>{steps[step].title}</h1>
					{steps[step].component}
				</div>

				{!token && (
					<>
						<p className={css['login']}>Already Have an Account?</p>
						<Button
							label='Login'
							color='white'
							variant='tertiary'
							action={() => {
								navigate('/login')
								// dispatch(setStep(0))
								// dispatch(clearCurrentMarker())
							}}
						/>
					</>
				)}
			</div>
			{/* <ToastContainer /> */}
		</div>
	)
}
